// Shared by the search fields (SearchBar, SubNavSearch) that call the dbo.Search procedure.

// dbo.Search takes @SearchString VARCHAR(20).
const MAX_SEARCH_LENGTH = 20;

// How long typing has to pause before a server search is sent.
export const SEARCH_DEBOUNCE_MS = 300;

/**
 * What to search for, from what was typed: a login/e-mail address ("eaa26npe@students.eaaa.dk") is cut
 * at the @ - Students.username holds only "EAA26NPE", and the search matches the start of it, so the
 * full address never found anyone (EAAA, 2026-10-08).
 */
export function toSearchTerm(typed: string | null | undefined): string {
  return toFilterTerm(typed).slice(0, MAX_SEARCH_LENGTH);
}

/**
 * What to filter the shown results by: all of what was typed (only cut at the @, as above). Not cut at
 * 20 like the server's term - the answer for the first 20 characters is narrowed down by the rest here.
 * Filtering by the 20-character term showed every course starting "GF - Pæd og alm dida" when the full
 * name was typed, and the one wanted wasn't among the first shown (2026-10-13).
 */
export function toFilterTerm(typed: string | null | undefined): string {
  return (typed ?? '').split('@')[0].trim();
}

/**
 * Whether the server has to be asked again, or the last answer can just be filtered in the browser.
 * dbo.Search matches usernames/ids that start with the term and names that contain it, so everything
 * matching a longer term is already in the answer for a term it starts with. Anything else - a shorter
 * term (deleting), or a different one - needs a new search.
 */
export function needsServerSearch(term: string, lastServerTerm: string): boolean {
  if (term.length < 2) return false; // dbo.Search returns nothing below 2 characters
  if (lastServerTerm.length < 2) return true;
  return !term.toLowerCase().startsWith(lastServerTerm.toLowerCase());
}
